
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
// import { useReactToPrint } from "react-to-print";
import { ArrowLeft, Download, FileDown, Mail, MoveLeft, Printer, PrinterCheck, Search, Settings } from 'lucide-react';
import classes from "./CustomerList.module.css"
import RotatingLogo from '../../Assets/Promix.svg'
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import api, { BASE_URL } from "../../Components/API/Api";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";











const CustomerList = () => {
  const location = useLocation();
  const receiptRef = useRef(null);
const [noData, setNoData] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [bearer, setBearer] = useState('');
  const [savingsLoading, setSavingsLoading] = useState(false);
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('userData'));
  

  const readData = async () => {
    try {
      const value = await localStorage.getItem('authToken');
     

      if (value !== null) {
        setBearer(value);
      }
    
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };





 const fetchReports = async () => {
  setSavingsLoading(true);
  try {
    const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");
    
    const response = await api.get(`/v1/member/all`, {
      params: {
    company_id: companyId

      },
      headers: {
        'Content-Type': 'application/json'
       
      }
    });

  

    const filtData1 = response.data?.data || [];
   

    if (filtData1.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'No Data Found',
        text: 'No data to be displayed.',
      });
      
    } else {
      
      setAccounts(filtData1);
      

    }
    

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      console.log(error);
      setAccounts([]);   // ✅ also clear here on error
      setNoData(true);
    }
  } finally {
    setSavingsLoading(false);
  }
};

  useEffect(() => {
    if (bearer) {
      fetchReports();
    }
  }, [bearer]);





const tableRef = useRef(null);

const printReport = () => {
  const printContents = receiptRef.current.innerHTML;

  const printWindow = window.open("", "_blank", "width=1200,height=900");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Members Database List</title>

        <style>

          body{
              font-family: Arial, sans-serif;
              margin:20px;
              color:#000;
          }

          h1{
              text-align:center;
              margin-bottom:5px;
          }

          p{
              text-align:center;
              margin-top:0;
              margin-bottom:25px;
          }

          table{
              width:100%;
              border-collapse:collapse;
          }

          th,td{
              border:1px solid #ddd;
              padding:8px;
              font-size:12px;
              text-align:left;
          }

          th{
              background:#f3f4f6;
              color:#000;
              font-weight:bold;
          }

          tr{
              page-break-inside:avoid;
          }

          @page{
              margin:10mm;
          }

        </style>

      </head>

      <body>

      ${printContents}

      </body>

    </html>
  `);

  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};

const downloadExcel = () => {
  if (!accounts.length) {
    Swal.fire({
      icon: "warning",
      title: "No Data",
      text: "There is no data to export.",
    });
    return;
  }

  const excelData = accounts.map((acc, index) => ({
    "S/N": index + 1,
    "Reg. No.": acc.member_number,
    "First Name": acc.first_name,
    "Last Name": acc.last_name,
    "Email": acc.email,
    "Phone Number": acc.phone_number,
    Address: acc.address,
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Optional: Set column widths
  worksheet["!cols"] = [
    { wch: 8 },
    { wch: 18 },
    { wch: 20 },
    { wch: 20 },
    { wch: 30 },
    { wch: 20 },
    { wch: 40 },
  ];

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Members Database"
  );

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(
    file,
    `Members_Database_Report_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`
  );
};


  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
      
        <div style={{ marginTop: 24 }} />
       
        <div  className={classes.tableContainer}>
         
         {accounts.length === 0 ? (
             <div
               style={{
                 textAlign: "center",
                 padding: "40px",
                 fontSize: "18px",
                 color: "#374151",
               }}
             >
               <p>No data to display</p>
             </div>
           ) : (
             <>
               <div className={classes.sideTools}>
                 {accounts.length > 0 && (
                   <div className={classes.filterIcons}>
                     <Mail
                       className={classes.iconBtns}
                       onClick={() => console.log("icon1")}
                     />
                     <PrinterCheck 
                      onClick={printReport}
                      //  onClick={() => window.print()}
                       className={classes.iconBtns}
                     />
                    <FileDown
  className={classes.iconBtns}
  onClick={downloadExcel}
/>
                   </div>
                 )}
               </div>
             <div ref={receiptRef} style={{
    // padding: "40px",
    background: "#ffffff",
  }}>
          <div className={classes.cntrTable} >
            <h1 className={classes.cntrTxt}>{userData?.company?.name}</h1>
              <p className={classes.cntrTx122} style={{marginBottom: "40px"}} >Members' Database Report
                       - {""} {new Date().toLocaleDateString()}
    
                     </p>
           

          </div>
 <table style={{ width: "100%", borderCollapse: "collapse", margin: 'auto' }}>
          <thead>
           
         
            <tr style={{borderBottom: "1px solid #d1d5db",}}>
      <th style={{ textAlign: 'left', fontSize: 12}}>S/N</th>
      <th style={{ textAlign: 'left', fontSize: 12}}>Reg. No.</th>
      <th style={{ textAlign: 'left', fontSize: 12}}>First Name</th>
      <th style={{ textAlign: 'left', fontSize: 12}}>Last Name</th>
      <th style={{ textAlign: 'left', fontSize: 12}}>E-Mail</th>
      <th style={{ textAlign: 'left', fontSize: 12}}>Phone Number</th>
      <th style={{ textAlign: 'left', fontSize: 12}}>Address</th>
    </tr>
          </thead>
         <tbody>
  {accounts?.map((acc, index) => (
    <tr key={index} style={{ borderBottom: "1px solid #d1d5db", }}>
      
      {/* Bank Name */}
      <td style={{ fontSize: 13, padding: 5 }}>
        {index + 1}
      </td>
      <td style={{ fontSize: 13, padding: 5 }}>
        {acc.member_number}
      </td>
      <td style={{ fontSize: 13, padding: 5, width: 200 }}>
        {acc.first_name}
      </td>
      <td style={{ fontSize: 13, padding: 5, width: 200 }}>
        {acc.last_name}
      </td>
      <td style={{ fontSize: 13, padding: 5 }}>
        {acc.email}
      </td>
      <td style={{ fontSize: 13, padding: 5 }}>
        {acc.phone_number}
      </td>
      <td style={{ fontSize: 13, padding: 5 }}>
        {acc.address}
      </td>

     
     
    </tr>
  ))}
</tbody>


        </table>
         </div>

         


 </>
  )}
 
        </div>
     <div style={{ marginTop: 27 }} />
 
      </div>
      {savingsLoading && (
                  <div className={classes.overlay}>
                    <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
                  </div>
                )}

    </div>
  )
}

export default CustomerList
